// Plain (no card background) hero section for the dashboard.
// Left: greeting + subtitle. Right: date badge + filter dropdowns.
// Renkler ve tipografi tema token'larindan gelir (ThemeProvider palette).

export const dashboardHeroStyles = {
  section: {
    px: { xs: 0.5, md: 0 },
    py: { xs: 1, md: 1.5 },
    mb: 3,
  },

  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 2,
    flexWrap: 'wrap',
  },

  left: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
    flex: '1 1 auto',
    minWidth: 0,
  },

  title: {
    fontWeight: 700,
    fontSize: { xs: '1.35rem', md: '1.5rem' },
    lineHeight: 1.2,
    color: 'text.primary',
    letterSpacing: '-0.02em',
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },

  wave: {
    display: 'inline-block',
    fontSize: '1.4rem',
  },

  subtitle: {
    color: 'text.secondary',
    fontSize: '0.875rem',
    fontWeight: 400,
    mt: 0.25,
  },

  right: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.25,
    flexWrap: 'wrap',
  },

  dateBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    px: 1.75,
    py: 1,
    height: 40,
    borderRadius: '8px',
    border: '1px solid',
    borderColor: 'grey.200',
    bgcolor: 'background.paper',
    color: 'text.primary',
    fontSize: '0.875rem',
    fontWeight: 500,
  },

  dateIcon: {
    fontSize: '1.05rem',
    color: 'primary.main',
  },

  filterControl: {
    minWidth: 175,
    '& .MuiOutlinedInput-root': {
      height: 40,
      borderRadius: '8px',
      bgcolor: 'background.paper',
      '& fieldset': { borderColor: 'grey.200' },
      '&:hover fieldset': { borderColor: 'grey.300' },
      '&.Mui-focused fieldset': { borderColor: 'primary.main' },
    },
    '& .MuiInputBase-input': {
      fontSize: '0.875rem',
      fontWeight: 500,
      color: 'text.primary',
      py: 0,
    },
    '& .MuiSelect-icon': {
      color: 'text.secondary',
    },
  },

  selectAdornment: {
    fontSize: '1.05rem',
    color: 'text.secondary',
    mr: 0.25,
  },
};
